import React from "react";
import {
  Link,
} from "react-router-dom";

import { CgFeed } from 'react-icons/cg'
import { AiOutlineAppstoreAdd } from 'react-icons/ai'
import { GiTalk } from 'react-icons/gi'

const Landing = () => {
  //const history = useHistory();

  return (
    <>
      <main className="dark:bg-gray-800 bg-white relative overflow-hidden h-screen">
        <header className="h-24 sm:h-32 flex items-center z-30 w-full">
          <div className="container mx-auto px-6 flex items-center justify-center lg:justify-between">
            <div className="uppercase text-gray-800 dark:text-white font-black text-3xl">
              Autolini
            </div>
            <div className="items-center hidden lg:flex">
              <nav className="text-gray-800 dark:text-white uppercase text-lg flex items-center ">
                <Link to='/' className="py-2 px-6 flex">
                  Accueil
                </Link>
                <Link to='/pricing' className="py-2 px-6 flex">
                  Tarifs
                </Link>
                <Link to='/app' className="py-2 px-6 flex">
                  Se connecter
                </Link>
              </nav>
            </div>
        </div>
      </header>
      <div className="items-center justify-center flex lg:hidden">
        <nav className="text-gray-800 dark:text-white uppercase text-lg flex items-center flex-col ">
          <Link to='/' className="py-2 px-6 flex">
            Accueil
          </Link>
          <Link to='/pricing' className="py-2 px-6 flex">
            Tarifs
          </Link>
          <Link to='/app' className="py-2 px-6 flex">
            Se connecter
          </Link>
        </nav>
      </div>
      <div className="bg-white dark:bg-gray-800 flex relative z-20 items-center overflow-hidden">
        <div className="container mx-auto px-6 flex relative py-16">
          <div className="sm:w-2/3 lg:w-2/5 flex flex-col relative z-20">
            <span className="w-20 h-2 bg-gray-800 dark:bg-white mb-12">
            </span>
            <h1 className="font-bebas-neue uppercase text-4xl sm:text-6xl font-black flex flex-col leading-none dark:text-white text-gray-800">
              Votre garage
              <span className="text-3xl sm:text-5xl">
                  dans votre poche
              </span>
            </h1>
            <p className="text-sm sm:text-base text-gray-700 dark:text-white">
              Optimisez, gérez, suivez toutes les données de votre garage grâce un outil de communication simple, rapide et efficace.
            </p>
            <div className="flex mt-8">
              <a href={`mailto:${process.env.REACT_APP_MAIL}?subject=[Autolini] Création de compte&body=Renseignez ici vos coordonnées afin que nous puissions vous contacter`} className="uppercase py-2 px-4 rounded-lg bg-blue-500 border-2 border-transparent text-white text-md mr-4 hover:bg-blue-400">
                Testez dès maintenant
              </a>
            </div>
          </div>
            <div className="hidden sm:block sm:w-1/3 lg:w-3/5 relative">
              <img src="/assets/status.png" className="m-auto w-1/2" alt='screenshot du status de la réparation sur le véhicule'/>
            </div>
          </div>
        </div>
      </main>
      <h2 className="font-bebas-neue uppercase text-xl sm:text-3xl font-black flex flex-col leading-none dark:text-white text-gray-800 ml-5 pl-5">
        Gérez votre activité mécanique en toute simplicité !
      </h2>
      <div className="sm:flex flex-wrap justify-center items-center text-center gap-8 pb-5">
          <div className="w-full sm:w-1/2 md:w-1/2 lg:w-1/4 px-4 py-4 bg-white mt-6  shadow-lg rounded-lg dark:bg-gray-800">
              <div className="flex-shrink-0">
                  <div className="flex items-center mx-auto justify-center h-12 w-12 rounded-md bg-green-500 text-white">
                      <CgFeed size={25} />
                  </div>
              </div>
              <h3 className="text-2xl sm:text-xl text-gray-700 font-semibold dark:text-white py-4">
                Suivi d'activité
              </h3>
              <p className="text-md  text-gray-500 dark:text-gray-300 py-4">
                Prise en charge client, activités mécaniques etc... Suivez en temps réel ce qui se passent dans votre garage !
              </p>
          </div>
          <div className="w-full sm:w-1/2 md:w-1/2 lg:w-1/4 px-4 py-4 mt-6 sm:mt-16 md:mt-20 lg:mt-24 bg-white shadow-lg rounded-lg dark:bg-gray-800">
              <div className="flex-shrink-0">
                  <div className="flex items-center mx-auto justify-center h-12 w-12 rounded-md bg-indigo-500 text-white">
                    <AiOutlineAppstoreAdd size={25} />
                  </div>
              </div>
              <h3 className="text-2xl sm:text-xl text-gray-700 font-semibold dark:text-white py-4">
                Moniteur d'accueil
              </h3>
              <p className="text-md text-gray-500 dark:text-gray-300 py-4">
                Organisez vos interventions, réparations et autres actes mécaniques en reprenant les codes de la restauration rapide.
              </p>
          </div>
          <div className="w-full sm:w-1/2 md:w-1/2 lg:w-1/4 mt-6  px-4 py-4 bg-white shadow-lg rounded-lg dark:bg-gray-800">
              <div className="flex-shrink-0">
                  <div className="flex items-center mx-auto justify-center h-12 w-12 rounded-md bg-blue-500 text-white">
                    <GiTalk size={25} />
                  </div>
              </div>
              <h3 className="text-2xl sm:text-xl text-gray-700 font-semibold dark:text-white py-4">
                Communication
              </h3>
              <p className="text-md  text-gray-500 dark:text-gray-300 py-4">
                Informez vos clients de l'avancée de son dossier à travers une page détaillant l'ensemble des étapes de la réparation de son véhicule.
              </p>
          </div>
      </div>
      <div className="bg-white dark:bg-gray-800 overflow-hidden relative ml-5">
        <div className="text-start lg:w-1/2 py-12 px-4 sm:px-6 lg:py-16 lg:px-8 z-20">
            <h2 className="text-2xl font-extrabold text-gray-800 dark:text-white sm:text-3xl font-bebas-neue uppercase">
                <span className="block">
                  Affichez votre plan de travail
                </span>
                <span className="block text-gray-500">
                  N'importe où et en temps réel
                </span>
            </h2>
            <p className="text-md mt-4 text-gray-400">
                Dans vos ateliers, salle d'attente, ou bureaux, <strong>affichez en temps réel la prise en charge des dossiers clients</strong>.
                Avec les écrans, votre équipe n'a pas besoin d'aller chercher les informations. Elle n'a qu'à lever la tête pour voir son plan de travail.
                &nbsp;<strong>Gagnez ainsi du temps en facilitant la communication au sein de votre organisation.</strong>
            </p>
            <div className="lg:mt-0 lg:flex-shrink-0">
                <div className="mt-12 inline-flex rounded-md shadow">
                    <a href={`mailto:${process.env.REACT_APP_MAIL}?subject=[Autolini] Création de compte&body=Renseignez ici vos coordonnées afin que nous puissions vous contacter`} className="py-4 px-6 bg-blue-600 hover:bg-blue-700 focus:ring-blue-500 focus:ring-offset-blue-200 text-white w-full transition ease-in duration-200 text-center text-base font-semibold shadow-md focus:outline-none focus:ring-2 focus:ring-offset-2  rounded-lg ">
                      Planifions une démo
                    </a>
                </div>
            </div>
        </div>
        <img src="/assets/tablet.png" className="absolute h-full max-w-1/2 hidden lg:block right-0 top-0" alt='screenshot moniteur activité sur tablette'/>
      </div>
      <div className="bg-gradient-to-r from-blue-400 via-blue-500 to-blue-500 overflow-hidden flex ml-5">
        <img src="/assets/mobileactivity.png" className="w-1/2 hidden lg:block " alt='screenshot mobile activité'/>
        <div className="text-end lg:w-1/2 py-12 px-4 sm:px-6 lg:py-16 lg:px-8 z-20">
            <h2 className="text-2xl font-extrabold text-white sm:text-3xl font-bebas-neue uppercase">
                <span className="block">
                  Gardez un oeil sur votre activité
                </span>
                <span className="block text-gray-600">
                  même à distance !
                </span>
            </h2>
            <p className="text-md mt-4 text-white">
                Qui s'est occupé du client ? A quel moment ? Quelles opérations sur le véhicule ont été effectuées ? <strong>Tracez toutes les données clées de votre activité et visualisez les même si vous n'êtes pas à votre bureau.</strong>
            </p>
            <div className="lg:mt-0 lg:flex-shrink-0">
                <div className="mt-12 inline-flex rounded-md shadow">
                    <a href={`mailto:${process.env.REACT_APP_MAIL}?subject=[Autolini] Création de compte&body=Renseignez ici vos coordonnées afin que nous puissions vous contacter`} className="py-4 px-6 bg-indigo-600 hover:bg-indigo-700 focus:ring-indigo-500 focus:ring-offset-indigo-200 text-white w-full transition ease-in duration-200 text-center text-base font-semibold shadow-md focus:outline-none focus:ring-2 focus:ring-offset-2  rounded-lg ">
                      Je m'inscris maintenant
                    </a>
                </div>
            </div>
        </div>
      </div>
      <div className="bg-white dark:bg-gray-800 overflow-hidden relative ml-5">
        <div className="text-start lg:w-1/2 py-12 px-4 sm:px-6 lg:py-16 lg:px-8 z-20">
            <h2 className="text-2xl font-extrabold text-gray-800 dark:text-white sm:text-3xl font-bebas-neue uppercase">
                <span className="block">
                  Gardez le contact avec vos clients
                </span>
                <span className="block text-gray-500">
                  en 1 seul clic
                </span>
            </h2>
            <p className="text-md mt-4 text-gray-400">
              <strong>Partagez la fiche d'intervention avec vos clients</strong> via une adresse internet. Arrêtez de téléphoner un par un vos clients <strong>lorsqu'une intervention est terminée, envoyez un SMS en un clic</strong>.
              <strong>Améliorez votre qualité de service et montrez votre professionnalisme en communiquant plus et mieux !</strong>
            </p>
            <div className="lg:mt-0 lg:flex-shrink-0">
                <div className="mt-12 inline-flex rounded-md shadow">
                    <a href={`mailto:${process.env.REACT_APP_MAIL}?subject=[Autolini] Création de compte&body=Renseignez ici vos coordonnées afin que nous puissions vous contacter`} className="py-4 px-6 bg-blue-600 hover:bg-blue-700 focus:ring-blue-500 focus:ring-offset-blue-200 text-white w-full transition ease-in duration-200 text-center text-base font-semibold shadow-md focus:outline-none focus:ring-2 focus:ring-offset-2  rounded-lg ">
                      Je me lance
                    </a>
                </div>
            </div>
        </div>
        <img src="/assets/mobilesms.png" className="absolute h-full max-w-1/2 hidden lg:block right-0 top-0" alt='screenshot mobile envoie sms'/>
      </div>
      <footer className="bg-white dark:bg-gray-800 w-full py-8">
          <div className="max-w-screen-xl mx-auto px-4">
              <ul className="mx-auto text-sm font-light flex flex-wrap justify-between">
                  <li className="my-2">
                    Copyright © Autolini 2021. Tous droits réservés.
                  </li>
                  <li className="my-2">
                      <a className="text-gray-400 hover:text-gray-800 dark:text-gray-300 dark:hover:text-white transition-colors duration-200" href="/politique_de_Confidentialite.pdf">
                        Politique de confidentialité
                      </a>
                  </li>
                  <li className="my-2">
                      <a className="text-gray-400 hover:text-gray-800 dark:text-gray-300 dark:hover:text-white transition-colors duration-200" href="/cgv.pdf">
                          Mentions légales et Conditions Générales d'Utilisation et de Vente
                      </a>
                  </li>
              </ul>
              <div className="text-sm font-light text-center">
                Crédits :
                  <a className="text-gray-400 hover:text-gray-800 dark:text-gray-300 dark:hover:text-white transition-colors duration-200" href="https://fr.freepik.com/psd/maquette" target='_blank' rel='nofollow noreferrer'>
                      &nbsp;Illustrations créées par zlatko_plamenov - freepik.com
                  </a>
              </div>
          </div>
      </footer>
    </>
  );
}

export default Landing
